export default function checkoutSummary({ main, on, elm }) {
  const toggle = elm.querySelector('[data-summary-toggle]');
  const products = elm.querySelector('[data-summary-products]');

  if (!toggle || !products) return;

  main(() => {
    syncHeight();
    on('click', '[data-summary-toggle]', toggleSummary);
    window.addEventListener('resize', syncHeight);
  });

  function syncHeight() {
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      products.style.maxHeight = `${products.scrollHeight}px`;
      products.classList.remove('is-collapsed');
    } else {
      products.style.maxHeight = '0px';
      products.classList.add('is-collapsed');
    }
  }

  function toggleSummary() {
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      closeSummary();
    } else {
      openSummary();
    }
  }

  function openSummary() {
    toggle.setAttribute('aria-expanded', 'true');
    products.classList.remove('is-collapsed');
    products.style.maxHeight = '0px';

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        products.style.maxHeight = `${products.scrollHeight}px`;
      });
    });
  }

  function closeSummary() {
    toggle.setAttribute('aria-expanded', 'false');
    products.style.maxHeight = `${products.scrollHeight}px`;
    void products.offsetHeight;
    products.style.maxHeight = '0px';
    products.classList.add('is-collapsed');
  }
}

export const model = {};
